import Mutations from '../../odata/mutations';

export default { ...new Mutations('candidateComment'), ...new Mutations('candidateComments') };
